import { render, staticRenderFns } from "./ResubmitRequest.vue?vue&type=template&id=fe746e8a&scoped=true"
import script from "./ResubmitRequest.vue?vue&type=script&lang=ts"
export * from "./ResubmitRequest.vue?vue&type=script&lang=ts"
import style0 from "./ResubmitRequest.vue?vue&type=style&index=0&id=fe746e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe746e8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
